export const MARKETING_ROUTES = ["/", "/billy-bank", "/billy-ia", "/offres"] as const;

export type MarketingRoute = (typeof MARKETING_ROUTES)[number];

export const ROUTE_TITLES: Readonly<Record<MarketingRoute, string>> = {
  "/": "Billy Bank — l’intelligence qui pilote votre entreprise",
  "/billy-bank": "Billy Bank — pilotage financier et expérience néobanque",
  "/billy-ia": "Billy IA — comprendre, proposer, agir sous votre contrôle",
  "/offres": "Billy Pro et Billy Infinity — demander une présentation",
};

export const PLAN_FACTS = {
  pro: {
    name: "Billy Pro",
    memory: "Jusqu’à 32 tours de conversation",
    retention: "Mémoire bornée à 30 jours et 512 Kio par compte",
    limits: {
      conversationTurns: "32",
      retention: "30 jours",
      storage: "512 Kio",
      storageQualifier: "maximum par compte",
    },
  },
  infinity: {
    name: "Billy Infinity",
    memory: "Jusqu’à 96 tours de conversation",
    retention: "Mémoire bornée à 90 jours et 2 Mio par compte autorisé",
    limits: {
      conversationTurns: "96",
      retention: "90 jours",
      storage: "2 Mio",
      storageQualifier: "maximum par compte autorisé",
    },
  },
} as const;

// This is an origin allowlist, not proof that an App Store listing is published.
export function allowlistedAppStoreUrl(candidate?: string): string | undefined {
  if (!candidate) return undefined;
  try {
    const url = new URL(candidate);
    return url.protocol === "https:" && url.hostname === "apps.apple.com"
      ? url.toString()
      : undefined;
  } catch {
    return undefined;
  }
}

export function normalizeMarketingRoute(pathname: string): MarketingRoute {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return MARKETING_ROUTES.includes(normalized as MarketingRoute)
    ? normalized as MarketingRoute
    : "/";
}

export type LeadPayload = {
  name: string;
  work_email: string;
  company: string;
  phone: string;
  project: string;
  message: string;
  consent: true;
  website: string;
  source_path: MarketingRoute;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
};

export function leadPayloadFromForm(
  form: FormData,
  sourcePath: MarketingRoute,
  search = "",
): LeadPayload {
  const text = (name: string) => String(form.get(name) ?? "").trim();
  const parameters = new URLSearchParams(search);
  const payload: LeadPayload = {
    name: text("name"),
    work_email: text("work_email").toLowerCase(),
    company: text("company"),
    phone: text("phone"),
    project: text("project"),
    message: text("message"),
    consent: true,
    website: text("website"),
    source_path: sourcePath,
  };
  (["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const)
    .forEach((key) => {
      const value = parameters.get(key)?.trim();
      if (value) payload[key] = value.slice(0, 128);
    });
  return payload;
}
